<script setup lang="ts">
import { computed, useTemplateRef } from "vue";

import StickyNote from "@/components/StickyNote/StickyNote.vue";
import FlexBackground from "@/components/background/FlexBackground.vue";
import { normalLinkColors } from "@/model/colors";
import { useBoardsStore } from "@/store/boards";

import LoadingIndicator from "../ui/LoadingIndicator.vue";
import LinkLayers from "./internal/LinkLayer/LinkLayers.vue";
import { useFluidBoard } from "./internal/useFluidBoard";

const board = computed(() => useBoardsStore().boardByType("flex"));
const rootRef = useTemplateRef("root");

const { active, isLoading, levelOfDetails, focusAndBlur } = useFluidBoard(board, rootRef);

defineExpose(focusAndBlur);

const background = computed(() => board.value.flexType?.background);
</script>

<template>
  <div :id="board.id" ref="root" tabindex="0" class="board board-flex">
    <LoadingIndicator v-if="active && isLoading" global />
    <LinkLayers :board :color="normalLinkColors.flex" />
    <FlexBackground :type="background" class="background" />
    <StickyNote
      v-for="card in board.cards"
      :key="card.data.id"
      :card="card.data"
      :card-meta="card.meta"
      :level-of-details
    />
  </div>
</template>

<style lang="scss">
.board-flex {
  .background {
    position: absolute;
    width: 100%;
    height: 100%;
  }
}
</style>
